import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { DriverPostAddService } from "./driver-post-add.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-driver-post-add",
  templateUrl: "./driver-post-add.component.html",
  styleUrls: ["./driver-post-add.component.sass"],
})
export class DriverPostAddComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private driverPostAddService: DriverPostAddService,
    private router: Router
  ) {}

  allPosts: any[] = [];
  itemsPerPage: number = 6;
  totalItems: number = 0;
  page: number = 1;

  ngOnInit(): void {
    this.getAllDriverPosts(this.page);
  }

  getAllDriverPosts(page: number): void {
    this.spinner.show();
    const data = {
      limit: this.itemsPerPage,
      page: page,
    };

    this.driverPostAddService.getDriverPosts(data).subscribe({
      next: (result: any) => {
        if (result.statusCode === 200) {
          this.allPosts = result.data;
          this.totalItems = result.pagination?.total || 0;
        } else {
          this.toastr.error(result.message || "Something went wrong");
        }
      },
      error: (err) => {
        this.toastr.error("API Error");
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }

  deleteData(data) {
    this.spinner.show();
    let id = data._id;
    this.driverPostAddService.delete(id).subscribe({
      next: (result: any) => {
        if (result.statusCode === 200) {
          this.toastr.success(result.message);
          this.getAllDriverPosts(this.page);
        } else {
          this.toastr.error(result.message || "Something went wrong");
        }
      },
      error: (err) => {
        this.toastr.error("API Error");
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }
   viewBids(data) {
    this.router.navigate(["dashboard/bids"], {
      queryParams: { id: data._id, type:"vacantVehicle" },
    });
  }
}
